import { useEffect, useMemo, useState, VFC } from 'react';
import { LoadingSpinner } from 'components/LoadingSpinner';
import { StepsProgressBar } from 'components/progress/ProgressBar';
import { useParams } from 'react-router-dom';
import { MeterContext } from 'contexts/Meter';
import { useIntl } from 'react-intl';
import { Layout } from '../../components/Layout/Layout';
import { getContentByStep } from './getContentByStep';
import { REPLACE_METER_STEPS_COUNT, useReplaceMeterStepsStore } from './useStepsStore';
import { getFooterByStep } from './getFooterByStep';
import { selectReplaceMeterFormFromPayload, useReplaceMeterStore } from './useStore';
import { ReplaceMeterSteps as messages } from './messages';
import { useContextMeter } from '../../hooks/useContextMeter';

export const MeterReplacementPage: VFC = () => {
  const intl = useIntl();
  const { id: serializedMeterId } = useParams();
  const meterId = parseInt(serializedMeterId ?? '');
  const { enmonMeter, inventoryMeter, isLoading } = useContextMeter(meterId);
  const [isFormReady, setIsFormReady] = useState(false);

  const { setForm } = useReplaceMeterStore();
  const { currentStep } = useReplaceMeterStepsStore();

  const PageContent = getContentByStep(currentStep);
  const PageFooter = getFooterByStep(currentStep);

  const renderContent = () => {
    if (isLoading || !isFormReady) {
      return <LoadingSpinner />;
    }
    return <PageContent />;
  };

  const contextValue = useMemo(
    () => ({ enmonMeter, inventoryMeter, isLoading }),
    [inventoryMeter, enmonMeter, isLoading],
  );

  useEffect(() => {
    if (enmonMeter && inventoryMeter && !isLoading) {
      setForm(selectReplaceMeterFormFromPayload(enmonMeter, inventoryMeter));
      setIsFormReady(true);
    }
  }, [enmonMeter, inventoryMeter, isLoading, setForm]);

  return (
    <MeterContext.Provider value={contextValue}>
      <Layout
        footerContent={<PageFooter />}
        headerContent={intl.formatMessage(messages[currentStep])}
        progressBarContent={<StepsProgressBar progressStep={currentStep} steps={REPLACE_METER_STEPS_COUNT} />}
      >
        {renderContent()}
      </Layout>
    </MeterContext.Provider>
  );
};
